import { Button, createStyles, Theme, Tooltip, Hidden, Zoom, withStyles } from "@material-ui/core";
import { inject, observer } from "mobx-react";
import React from "react";
import { PredefinedRole } from "../../domain/auth/PredefinedRole";
import { PredefinedStoreName } from "../enums/PredefinedStoreName";

import i18n from "../../services/localization/i18n";
import { IContextStoreProps } from "../../stores/IContextStoreProps";
import AppIcon from "../shared/AppIcon";
import { AppIconType } from "../shared/AppIconType";
import meetingDataService from "../../services/api/MeetingDataService";


const styles = (theme: Theme) => createStyles({
    endInterviewButton: {
        "&:hover": {
            backgroundColor: theme.palette.error.dark,
        },
        alignSelf: "center",
        backgroundColor: theme.palette.error.main,
        color: theme.palette.getContrastText(theme.palette.error.main),
        height: theme.spacing(6),
        margin: theme.spacing(),
    },
});

interface IEndMeetButtonProps {
    classes: {
        endInterviewButton: string;
    };
    ending: boolean;
    collapsed?: boolean;
    onEndMeetSuggested: () => void;
}

interface IEndMeetButtonState {
    endMeetTooltip: boolean;
    
}

@inject(PredefinedStoreName.CONTEXT)
@observer
class EndMeetButton extends React.Component<IEndMeetButtonProps & IContextStoreProps, IEndMeetButtonState> {

    private clockingRequested = false;

    /**
     *
     */
    constructor(props: IEndMeetButtonProps & IContextStoreProps) {
        super(props);

        this.state = {
            endMeetTooltip: false,
        };
    }

    public render() {

        const { classes, collapsed, onEndMeetSuggested } = this.props;
        const { finishedMeet, role } = this.props.contextStore!;

        const privilegedUser = role === PredefinedRole.POWER_USER || role === PredefinedRole.ADMIN;

        const endMeet = i18n.t("layout_meet_end");
        const billableTime = this.getBillableTIme();

        const remainingTime = finishedMeet ? `${endMeet}` : `${endMeet} ${billableTime}`;
        const buttonCaption = (privilegedUser || collapsed) ? remainingTime : i18n.t("layout_meet_leave");

        return  <Tooltip
            title={privilegedUser
                    ? i18n.t("layout_finish_endmeet")!
                    : i18n.t("layout_finish_leavemeet")!
            }
            placement="bottom"
            TransitionComponent={Zoom}
            open={this.state.endMeetTooltip}>
                <Button variant="outlined"
                        color="primary"
                        disabled={this.props.ending}
                        // tslint:disable-next-line: jsx-no-lambda
                        onClick={() => {
                            onEndMeetSuggested();
                        }}
                        // tslint:disable-next-line: jsx-no-lambda
                        onMouseEnter={() => this.setState({endMeetTooltip: true})}
                        // tslint:disable-next-line: jsx-no-lambda
                        onMouseLeave={() => this.setState({endMeetTooltip: false})}
                        className={classes!.endInterviewButton}>
                            
                                { !collapsed &&
                                    <>
                                        <Hidden smDown={true}>
                                            { buttonCaption}
                                        </Hidden>
                                        <Hidden mdUp={true}>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                                <AppIcon icon={AppIconType.CallEnd} />
                                                {billableTime}
                                            </div>
                                        </Hidden>
                                    </>
                                }
                                {
                                    collapsed && 
                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                                            <AppIcon icon={AppIconType.CallEnd} />
                                            {billableTime}
                                        </div>
                                }
                            
                </Button>
        </Tooltip>;
    }

    
    private getBillableTIme = () => {

        const { billableDurationInSeconds, schedulingInfo, resourceId  } = this.props.contextStore!;

        let billableSeconds = 0;
        if (billableDurationInSeconds) {
            billableSeconds = billableDurationInSeconds;
        }

        let billableTime: string = "";

        if (schedulingInfo) {
            const scheduledSeconds = schedulingInfo!.duration * 60;
            let remainingSeconds = scheduledSeconds - billableSeconds;

            if (remainingSeconds < 0) {
                billableTime = "-";
                
                if (!this.clockingRequested && remainingSeconds < -10) {
                    this.clockingRequested = true;
                    if (resourceId) {
                        // NOTE: m1, 24.7.2020 - Inform the server to check this Meet if it should be terminated or not 
                        meetingDataService.clockAsync(resourceId);
                    }
                }
            }

            remainingSeconds = Math.floor(Math.abs(remainingSeconds));
            const minutes = Math.floor(remainingSeconds / 60);
            const seconds = remainingSeconds - minutes * 60;

            if (minutes < 10) {
                billableTime += `0${minutes}`;
            } else {
                billableTime += `${minutes}`;
            }

            if (seconds < 10) {
                billableTime += `:0${seconds}`;
            } else {
                billableTime += `:${seconds}`;
            }
        }

        return billableTime;

    }
}

export default withStyles(styles)(EndMeetButton);
